import { isValidElement, type ReactElement, type ReactNode } from "react";

export type TooltipTranslationElement = ReactElement<{ tooltipText: string }>;

export function hasTooltipTranslation(
  value: ReactNode,
): value is TooltipTranslationElement {
  return (
    isValidElement(value) &&
    typeof value.props === "object" &&
    value.props !== null &&
    "tooltipText" in value.props &&
    typeof value.props.tooltipText === "string"
  );
}
